const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'd6bebab'

export default websiteVersion
